// extracted by mini-css-extract-plugin
module.exports = {"SmallSpinner":"SmallSpinner_SmallSpinner__pwWuW","spin":"SmallSpinner_spin__3AbEn"};